import React from "react";
import {useI18next} from 'gatsby-plugin-react-i18next';
import {graphql, useStaticQuery} from "gatsby";
import Link from "./Link";


export const LangSwitcher = ({translations}) => {
  let slug = translations?.length > 0 && translations[0]?.slug || '';
  let uri = translations?.length > 0 && translations[0]?.uri || '';

  const isFrontPage = translations?.length > 0 && translations[0]?.isFrontPage || false;
  slug = isFrontPage ? '' : slug;

  const {languages, language, routed} = useI18next();

  const { wp } = useStaticQuery(graphql`
		query {
			wp {
        languages {
          name
          slug
          locale
        }
      }
		}
	`);
  const wpLangs = wp.languages || [];

  const getLangLabel = (code = 'en') => {
    const wpLang = wpLangs.filter( item => item.slug === code);
    return wpLang?.length > 0 ? wpLang['0']?.name : ''
  }
  return translations?.length !== 0 && (
    <div className="me-5 me-lg-6">
      {languages.map((lng) => lng !== language ? (
        <Link className="nav-link" to={uri || (!routed ? `/${lng}/${slug}` : `/${slug}`)} key={lng}>
          {getLangLabel(lng)}
        </Link>
      ) : null)}
    </div>
  )
}
